import Api from '@/services/Api'

export default {
  alldevices (params) {
    return Api().post('deviceall', params)
  },
  allcareusers (params) {
    return Api().post('careUserall', params)
  },
  allheartrates (params) {
    return Api().post('heartRateAll', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/ReportService.js